import {
  CalendarOutlined,
  EditOutlined,
  MoreOutlined,
  SendOutlined,
  StopOutlined,
} from '@ant-design/icons'
import { Dropdown, Form, Menu, Modal, Tooltip, message } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useMediaQuery } from 'react-responsive' // PDF Viewer
import { blue } from '../../color'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import ConnectedCommitteeDocumentOutgoingHistoryBlock from '../../components/ConnectedCommitteeDocumentOutgoingHistoryBlock'
import ConnectedCommitteeDocumentUserReadingStatusModal from '../../components/ConnectedCommitteeDocumentUserReadingStatusModal'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import PageTitle from '../../components/PageTitle'
import { systemName } from '../../config'
import { DATE_FORMAT_DEFAULT, DOCUMENT_STATUS } from '../../constants'
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
} from '../../layouts/ConnectedCommitteeDocumentDetailLayout/ConnectedCommitteeDocumentDetailLayoutStyled'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import utils from '../../utils'

const CateDocumentOutgoingDocDetailPage = props => {
  const [recover, setShowRecover] = useState(false)
  const RECOVER = { id: '13', description: 'Yêu cầu lấy lại văn bản điện tử' }

  const [form] = Form.useForm()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    match,
    commonStore,
    connectedCommitteeDocumentStore,
    loadingAnimationStore,
    fileStore,
    cateDocumentStore,
  } = props

  const [showUserReadingModal, setShowUserReadingModal] = useState(false)

  const { documentId } = match.params
  const {
    listDocumentsType,
    listDocumentsStatus,
    sentCateDocument,
  } = cateDocumentStore

  const [document, setDocument] = useState(null)

  const {
    attachments,
    bussiness_doc_type,
    documentNumber,
    history,
    statusId,
    status,
    subject,
    edocs_bussiness,
    sendDate,
    promulgationDate,
    organs,
  } = document || {}
  const title = subject

  const [loading, setLoading] = useState(false)
  const [attachmentForView, setAttachmentForView] = useState()

  useEffect(() => {
    listDocumentsType()
    listDocumentsStatus()
  }, [])

  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    setLoading(true)
    cateDocumentStore
      .getDocumentsOutgoingById(documentId)
      .then(response => {
        setDocument(response.data)
      })
      .catch(err => {
        props.history.push('/cate-document/outgoing-document')
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => {
        setLoading(false)
        loadingAnimationStore.showSpinner(false)
      })

    return () => {
      form.resetFields()
    }
  }, [documentId])
  const renderAction = bussiness_doc_type => {
    switch (bussiness_doc_type) {
      case '0':
        return 'tạo mới'
      case '1':
        return 'thu hồi'
      case '2':
        return 'cập nhật'
      case '3':
        return 'thay thế'
      default:
        return ''
    }
  }
  const renderInfoText = string => {
    if (string) {
      if (string.length <= 20) return string
      return (
        <Tooltip title={string}>
          {string.substring(0, 20).concat('...')}
        </Tooltip>
      )
    }
  }

  const reasonRecover = useRef(null)
  const handleRecover = () => {
    loadingAnimationStore.showSpinner(true)
    const reason = reasonRecover.current.state.value
    connectedCommitteeDocumentStore
      .updateStatusOutgoingCommitteeDocumentById(
        documentId,
        RECOVER.id,
        reason && reason.length > 0 ? reason : RECOVER.description,
        null
      )
      .then(() => {
        message.success('Gửi yêu cầu lấy lại văn bản thành công!')
      })
      .catch(error => {
        message.error(error.vi)
      })
      .finally(() => {
        setShowRecover(false)
        connectedCommitteeDocumentStore
          .getOutgoingCommitteeDocumentById(documentId)
          .finally(() => loadingAnimationStore.showSpinner(false))
      })
    reasonRecover.current.state.value = undefined
  }

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.fileName))
      )
    )
  }, [attachments])

  const renderAttachmentFile = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.fileId}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.fileName)}
      />
    ),
    [attachmentForView]
  )

  const send = () => {
    loadingAnimationStore.showSpinner(true)
    sentCateDocument({
      id: documentId,
      document_status_id: 1,
    })
      .then(() => {
        message.success('Gửi văn bản thành công!')
        return cateDocumentStore.getDocumentsOutgoingById(documentId)
      })
      .then(response => {
        setDocument(response.data)
      })
      .catch(err => {
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  const documentHandleDropdown = (
    <Menu>
      {(statusId === 99 || statusId === 1 || statusId === 2 || !statusId) && (
        <Menu.Item
          style={{ color: blue }}
          icon={<SendOutlined />}
          onClick={() => send()}>
          Gửi văn bản
        </Menu.Item>
      )}

      <Menu.Item
        style={{ color: blue }}
        icon={<EditOutlined />}
        onClick={() =>
          props.history.push(
            `/cate-document/outgoing-document/update/${documentId}`
          )
        }>
        Cập nhật văn bản
      </Menu.Item>
      {/* <Menu.Item
        style={{ color: 'red' }}
        onClick={() => setShowRecover(true)}
        icon={<StopOutlined />}>
        <span>Yêu cầu lấy lại văn bản</span>
      </Menu.Item>
      <Menu.Item
        danger
        onClick={() => message.warning('Chức năng đang cập nhật!')}
        icon={<DeleteOutlined />}>
        Xóa văn bản
      </Menu.Item> */}
    </Menu>
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={title ? title : 'Undefined'}
        showTitle={true}
        color={commonStore.appTheme.solidColor}>
        <HeadingButtonWrapper>
          {status !== '100' && status !== '200' && status !== '300' && (
            <Dropdown overlay={documentHandleDropdown} trigger={['click']}>
              <span className={'btn-style'}>
                <MoreOutlined />
              </span>
            </Dropdown>
          )}
        </HeadingButtonWrapper>
      </PageTitle>
      <DocumentContentWrapper>
        <BlockLeft>{renderAttachmentFile}</BlockLeft>

        <BlockRight>
          <ContentBlockWrapper>
            <TitleContentBox>Thông tin chung</TitleContentBox>
            <DocumentInfoList>
              <dt>Số văn bản</dt>
              <dd>{documentNumber && renderInfoText(documentNumber)}</dd>
              {/* <dt>Nơi ban hành</dt>
              <dd>{sender_organ_name && WordBreak(sender_organ_name)}</dd> */}
              <dt>Nơi nhận</dt>
              <dd>
                {organs &&
                  organs.map((organ, index) => {
                    return <div key={index}> {WordBreak(organ?.organName)}</div>
                  })}
              </dd>
              <dt>Ngày ban hành</dt>
              <dd>
                {promulgationDate && (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>
                      {moment(promulgationDate).format(DATE_FORMAT_DEFAULT)}
                    </span>
                  </>
                )}
              </dd>
              <dt>Ngày gửi</dt>
              <dd>
                {sendDate && (
                  <>
                    <CalendarOutlined style={{ color: blue, marginRight: 4 }} />
                    <span>{moment(sendDate).format(DATE_FORMAT_DEFAULT)}</span>
                  </>
                )}
              </dd>
              <dt>Trạng thái</dt>
              <dd>{DOCUMENT_STATUS[statusId]?.value}</dd>
              {/* {edocs_bussiness &&
                edocs_bussiness.length > 0 &&
                edocs_bussiness.map(item => (
                  <Fragment key={item.doc_id}>
                    <dt>{`Văn bản bị ${renderAction(bussiness_doc_type)}`}</dt>
                    <dd>
                      <Tooltip title={item.title}>
                        <Link
                          to={`/connected-committee-document/outgoing-document/view/${item.doc_id}`}>
                          {item.code}
                        </Link>
                      </Tooltip>
                    </dd>
                  </Fragment>
                ))} */}
              <dt>Tài liệu đính kèm</dt>
              <dd>
                <div>
                  {attachments ? (
                    attachments.map(file => (
                      <FileItem
                        key={file.fileId}
                        file_id={file.fileId}
                        file_name={file.fileName}
                        file_type={utils.getExtensionFile(file.fileName)}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )}
                </div>
              </dd>
            </DocumentInfoList>
          </ContentBlockWrapper>
          <div style={{ marginBottom: 15 }} />
          <ContentBlockWrapper>
            <ConnectedCommitteeDocumentOutgoingHistoryBlock
              title={'Lịch sử văn bản đi'}
              history={history}
            />
          </ContentBlockWrapper>
        </BlockRight>
      </DocumentContentWrapper>

      <ConnectedCommitteeDocumentUserReadingStatusModal
        modalVisible={showUserReadingModal}
        onClose={() => setShowUserReadingModal(false)}
      />

      <Modal
        visible={recover}
        cancelText={'Huỷ'}
        onCancel={() => setShowRecover(false)}
        okText={'Yêu cầu lấy lại văn bản'}
        okType={'danger'}
        onOk={handleRecover}
        title={
          <Fragment>
            <StopOutlined
              style={{
                color: 'red',
                marginRight: 10,
              }}
            />
            Lấy lại văn bản
          </Fragment>
        }>
        <TextArea
          ref={reasonRecover}
          rows={4}
          placeholder={'Nhập lý do lấy lại'}
        />
      </Modal>
    </DashboardLayout>
  )
}

CateDocumentOutgoingDocDetailPage.propTypes = {}

export default inject(
  'commonStore',
  'connectedCommitteeDocumentStore',
  'cateDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'fileStore'
)(observer(CateDocumentOutgoingDocDetailPage))
